/**
 * Provider values stored in the `accounts.provider` column. Part of the shared
 * auth DB schema — both storefronts persist the same values.
 */
export enum AccountProvider {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  PASSWORD = 'password',
}

/** NextAuth account type. Not persisted in the `accounts` table. */
export enum AccountType {
  OAUTH = 'oauth',
  OIDC = 'oidc',
  CREDENTIALS = 'credentials',
}

/** A linked provider account — mirrors `accounts.provider` / `accounts.provider_account_id`. */
export interface LinkedAccount {
  provider: AccountProvider;
  providerAccountId: string;
}

/** The social (non-password) providers. */
export const SOCIAL_PROVIDERS = [AccountProvider.GOOGLE, AccountProvider.FACEBOOK] as const;
